export enum TiposLista {
    no_localizable = 'no_localizable',
    eliminados = 'eliminados',
    definitivo = 'definitivo',
    favorables = 'favorables',
    sentencias = 'sentencias',
    desvirtuados = 'desvirtuados',
    presuntos = 'presuntos'
}
